import { ref } from "vue";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    slides: Array,
    pageNumber: Number,
    totalPages: Number
  },
  computed: {},
  setup() {
    const swiper = ref();
    const onSwiper = instance => {
      swiper.value = instance;
      swiper.value.allowTouchMove = false;
    };
    return {
      modules: [Navigation],
      onSwiper,
      swiper
    };
  }
};